
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile-discovery/create",
      function () {
        return require("private-next-pages/profile-discovery/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile-discovery/create"])
      });
    }
  